import ConfirmAPI from 'utils/api/ConfirmAPI';
import { getFriendlyErrorMessageIfErrorOccurred } from 'utils/util/util';
import { type ThreadedComment } from './threadedComments';

type ProxyParameters = {
  proxy: string | undefined;
  organization_id: number | undefined;
  organization: number | undefined;
};

export interface CreateThreadedCommentPayload {
  content_type: number;
  object_id: number;
  body: string;
  is_private: boolean;
  parent_comment?: number;
}

// Returned by create/update: the up-to-date public comment count for the
// commented-on object, recomputed server-side on every mutation. Toggling
// one comment's privacy can change whether other comments (its replies)
// count as publicly visible too, so the client uses this number directly
// as the badge count instead of re-deriving it from a locally cached list.
export interface ThreadedCommentMutationResponse extends ThreadedComment {
  public_comment_count: number;
}

export const threadedCommentsApi = {
  createComment: (
    proxyParameters: ProxyParameters,
    payload: CreateThreadedCommentPayload,
    onSuccess: (comment: ThreadedCommentMutationResponse) => void,
    onError: (error: unknown) => void
  ) => {
    ConfirmAPI.sendRequestToConfirm(
      'POST',
      'threaded-comments',
      { ...proxyParameters, ...payload },
      (
        data: ThreadedCommentMutationResponse,
        error: unknown,
        hardErrorMessage: unknown
      ) => {
        if (error) {
          onError(
            getFriendlyErrorMessageIfErrorOccurred(error, hardErrorMessage)
          );
          return;
        }
        onSuccess(data);
      }
    );
  },

  updateIsPrivate: (
    commentId: number,
    isPrivate: boolean,
    proxyParameters: ProxyParameters,
    onSuccess: (comment: ThreadedCommentMutationResponse) => void,
    onError: (error: unknown) => void
  ) => {
    ConfirmAPI.sendRequestToConfirm(
      'PATCH',
      `threaded-comments/${commentId}`,
      { ...proxyParameters, is_private: isPrivate },
      (
        data: ThreadedCommentMutationResponse,
        error: unknown,
        hardErrorMessage: unknown
      ) => {
        if (error) {
          onError(
            getFriendlyErrorMessageIfErrorOccurred(error, hardErrorMessage)
          );
          return;
        }
        onSuccess(data);
      }
    );
  },
};
